import {
  StyleRulesCallback,
  WithStyles,
  withStyles as withStylesCb
} from "@material-ui/core/styles";

const styles: StyleRulesCallback = ({ spacing: { unit }, breakpoints }) => {
  return {
    container: {
      margin: `0 auto ${unit * 5}px`,
      maxWidth: unit * 190,
      [breakpoints.down("lg")]: {
        margin: `${unit * 5}px ${unit * 3}px`
      },
      [breakpoints.down("sm")]: {
        backgroundColor: "#ffffff",
        margin: 0
      },
      "&:before": {
        backgroundColor: "#2839cc",
        backgroundImage:
          "url(https://res.cloudinary.com/compara/image/upload/q_auto/v1565728605/assets/home/business/default-hero-bg.svg)",
        backgroundSize: "cover",
        content: "''",
        display: "block",
        height: "168px",
        left: 0,
        position: "absolute",
        top: "4rem",
        width: "100%",
        zIndex: -1
      }
    },
    form: {
      borderRadius: unit * 2,
      padding: `${unit * 2}px 0 ${unit * 4}px`,
      [breakpoints.down("sm")]: {
        boxShadow: "none"
      }
    },
    space: {
      marginLeft: `${unit * 4}px`
    },
    withSideBar: {
      margin: "0 auto",
      maxWidth: "800px"
    },
    header: {
      margin: "3rem 0"
    }
  };
};

export type Styles = WithStyles<typeof styles>;
export const withStyles = withStylesCb(styles);
